export default __webpack_public_path__ + "static/sophiamedi-dc4ec1702b57e332b5586ed5695a8f1b.png";